import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['container', 'step', 'back'];

  connect() {
    this.activeClass = 'guided-flow_step--active';
    this.showStep();
  }

  showStep() {
    this.stepTargets.forEach((step, index) => {
      if (index === this.index) {
        step.classList.add(this.activeClass);
      } else {
        step.classList.remove(this.activeClass);
      }
    });
    if (this.index === 0) {
      $(this.backTarget).hide();
    } else {
      $(this.backTarget).show();
    }
  }

  next() {
    if (this.index < this.stepTargets.length - 1) this.index += 1;
  }

  prev() {
    if (this.index > 0) this.index -= 1;
  }

  get index() {
    return parseInt(this.data.get('index') || 0, 10);
  }

  set index(value) {
    this.data.set('index', value >= 0 ? value : 0);
    this.showStep();
  }
}
